<template>
  <div class="l-block__detail">
    <TitleSub level="h3">
      <span class="title">施策の効果を見る</span>
      <span class="description"
        >「成果チェック」機能で施策の効果（順位やクリック率）を確認しましょう。</span
      >
    </TitleSub>

    <div>
      <!-- 施策の効果を見る -->
      <div class="c-table c-table--observation">
        <div class="c-table__header">
          <div class="items">
            <div class="item_header_keyword">
              通知日（<span :class="{ active: tasksCount > 0 }"
                >{{ tasksCount }}件</span
              >）
            </div>
          </div>
        </div>

        <div class="c-table__body">
          <div v-if="isLoading">
            <div class="items">
              <Loading variant="inline" />
            </div>
          </div>

          <template v-else-if="tasksCount === 0">
            <Error variant="inline">
              <template slot="title">
                通知がありません。
              </template>
              <p>
                タスク完了から1ヶ月経過したリライトまたは、タイトル変更タスクが表示されます。
              </p>
            </Error>
          </template>

          <template v-else>
            <ListItemRefineContentObservation
              v-for="item in sortedItems"
              :key="item.id"
              :item="item"
              :project="project"
            />
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TitleSub from '@/components/TitleSub';
import Loading from '@/components/Loading';
import Error from '@/components/Error';
import ListItemRefineContentObservation from '@/components/dashboard/ListItemRefineContentObservation';
import utils from '@/utils';

export default {
  props: {
    tasks: {
      type: Array,
      required: true
    },
    tasksCount: {
      type: Number,
      required: true
    },
    isLoading: {
      type: Boolean,
      required: true
    },
    project: {
      type: Object,
      required: true
    }
  },

  components: {
    TitleSub,
    Loading,
    Error,
    ListItemRefineContentObservation
  },

  data() {
    return {
      params: {
        sort: {
          name: 'typeDoneDate',
          orderby: 'desc',
          type: 'date'
        }
      }
    };
  },

  methods: {
    completeTask(task) {
      this.$emit('completeTask', task);
    }
  },

  computed: {
    sortedItems() {
      return utils.sort(
        this.tasks,
        this.params.sort.type,
        this.params.sort.orderby,
        this.params.sort.name
      );
    }
  }
};
</script>
